import React from "react";
import "../css/OrderNow.css";
import order1 from "../images/order1.png";
import order2 from "../images/order2.png";
import order3 from "../images/order3.png";
import order4 from "../images/order4.png";

function OrderNow() {
  return (
    <div className="orderNow container">
      <h1 className="text-center">
        Order Now<span>.</span>
      </h1>
      <p className="text-center">
        Order our product in your lovely marketplace.
      </p>
      <div className="row">
        <div className="col-lg-3 col-md-3 col-6 m-auto">
          <a href={"https://www.bukalapak.com/"}>
            <img src={order1} className="img-fluid image m-auto" alt="" />
          </a>
          {/* <div className="middle">
                    <div className="text">
                    <h3><a href={'https://www.bukalapak.com/'} >Bukalapak</a></h3>
                        <i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i>
                    </div>
                </div> */}
        </div>
        <div className="col-lg-3 col-md-3 col-6 m-auto">
          <a href={"https://www.tokopedia.com/"}>
            <img src={order2} className="img-fluid image m-auto" alt="" />
          </a>
          {/* <div className="middle">
                    <div className="text"><h3>Tokopedia</h3>
                        <i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i>
                    </div>
                </div> */}
        </div>
        <div className="col-lg-3 col-md-3 col-6 m-auto">
          <a href={"https://shopee.co.id/"}>
            <img src={order3} className="img-fluid image m-auto" alt="" />
          </a>
          {/* <div className="middle">
                    <div className="text"><h3>Shopee</h3>
                        <i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i>
                    </div>
                </div> */}
        </div>
        <div className="col-lg-3 col-md-3 col-6 m-auto">
          <a href="https://wa.me/+6285161016522">
            <img src={order4} className="img-fluid image m-auto" alt="" />
          </a>
          {/* <div className="middle">
                    <div className="text"><h3>WhatsApp</h3>
                        <i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i><i className="fa fa-star" aria-hidden="true"></i>    
                    </div>
                </div> */}
        </div>
      </div>
    </div>
  );
}

export default OrderNow;
